import { render, staticRenderFns } from "./bargainRecord.vue?vue&type=template&id=07a925be&scoped=true"
import script from "./bargainRecord.vue?vue&type=script&lang=js"
export * from "./bargainRecord.vue?vue&type=script&lang=js"
import style0 from "./bargainRecord.vue?vue&type=style&index=0&id=07a925be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a925be",
  null
  
)

export default component.exports